import { Component, Input } from '@angular/core';

@Component({
    selector: 'thr-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
    @Input()
    public show = false;
}
